<template>
  <div class="white">
    <v-layout row wrap>
      <v-flex xs12 lg4 >
         <v-container fluid grid-list-xl class="pt-3 " v-if="!Classes">
        <v-layout row wrap class="">
          <div class="w-100" xs12 >
            <v-flex class="pb-0">
              <v-card  v-for="(clss,i) in cards" :key="i" class="mb-3 card-r shadow-1 pt-1 pb-1" color="white">
                <v-list tow-line subheader class="pa-0 transparent">
                  <v-list-tile avatar>
                    <v-list-tile-avatar @click="classtype(clss.type)" size="35px" color="#077FFF">
                      <img class="objec-fit br-1" :src="clss.img">
                    </v-list-tile-avatar>
                    <v-list-tile-content @click="classtype(clss.type)">
                      <v-list-tile-title class="t-color-grey-d font-weight-bold">
                        {{clss.name}}
                      </v-list-tile-title>
                      <v-list-tile-sub-title class="t-color-grey-l"></v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-card-actions class="pa-0">
                      <v-btn small icon @click="viewcls = true" class= "w-100 no-shadow card-r text-primary text-capitalize">
                        <v-icon class="text-primary">visibility</v-icon></v-btn>
                    </v-card-actions>
                  </v-list-tile>
                </v-list>
              </v-card>
            </v-flex>
          </div>
          <v-dialog class="pa-0 border-r card-r display-unset w-100 z-10" v-model="viewcls" width="600">
            <v-card class="card-r grey lighten-4 no-shadow">
              <v-layout row xs12 justify-center>
                <v-flex xs12>
                  <v-layout wrap>
                    <v-flex xs12 class="ma-2">
                      <v-btn small icon @click="viewcls = false" class="right grey--text f-15"><v-icon>close</v-icon></v-btn>
                      <div class="text-sm-left pt-1 f-20 pl-2 font-weight-bold t-color-grey-l">Urban Drive</div>
                    </v-flex>
                    <v-divider></v-divider>
                  </v-layout>
                  <v-container fluid grid-list-md >
                    <v-card class=" no-shadow nope card-r text-xs-left pa-2">

                      <v-layout xs12 row wrap class="py-2">
                        <v-flex xs12 offset-xs0 class="text-xs-left py-0">
                          <span class="f-15 font-weight-bold text-grey-dark">Duration :</span>
                          <span class="f-15 font-weight-bold text-primary">135 Minutes</span>
                        </v-flex>
                        <!--<v-flex xs12 offset-xs0 class="text-xs-left py-0">-->
                        <!--<span class="f-15 font-weight-bold text-grey-dark">Date: </span>-->
                        <!--<span class="f-15 font-weight-bold text-primary">2020-01-14</span>-->
                        <!--</v-flex>-->
                        <!--<v-flex xs12 offset-xs0 class="text-xs-left py-0">-->
                        <!--<span class="f-15 font-weight-bold text-grey-dark">time: </span>-->
                        <!--<span class="f-15 font-weight-bold text-primary">06:00:00</span>-->
                        <!--</v-flex>-->
                        <!--<v-flex xs12 offset-xs0 class="text-xs-left py-0">-->
                        <!--<span class="f-15 font-weight-bold text-grey-dark">Location: </span>-->
                        <!--<span class="f-15 font-weight-bold text-primary">Køreskolen</span>-->
                        <!--</v-flex>-->
                        <v-flex xs12 class="text-xs-left py-0 ">
                          <span class="f-17 font-weight-bold text-grey-dark">Description:</span>
                          <span class="f-15 text-primary font-weight-bold pb-2">dette er en drivende klasse studerende</span>
                          <!--<p class="descriptionList" v-for="tag in ClassData.tags">{{tag.key}} - {{tag.description}}</p>-->
                          <p class="pa-1 card-r text-capitalize text-grey-dark card-r grey lighten-3">
                            10 - FORBEREDELSE TIL KØREPRØVE</p>
                          <p class="pa-1 card-r text-capitalize text-grey-dark card-r grey lighten-3">
                            10.1 - Betingelser for at få kørekort</p>
                          <span v-show="read">
                                          <p class="pa-1 card-r text-capitalize text-grey-dark card-r grey lighten-3">
                                      10 - FORBEREDELSE TIL KØREPRØVE</p>
                                    <p class="pa-1 card-r text-capitalize text-grey-dark card-r grey lighten-3">
                                      10.1 - Betingelser for at få kørekort</p>
                                    <p class="pa-1 card-r text-capitalize text-grey-dark card-r grey lighten-3">
                                      10 - FORBEREDELSE TIL KØREPRØVE</p>
                                    <p class="pa-1 card-r text-capitalize text-grey-dark card-r grey lighten-3">
                                      10.1 - Betingelser for at få kørekort</p>
                                    <p class="pa-1 card-r text-capitalize text-grey-dark card-r grey lighten-3">
                                      10 - FORBEREDELSE TIL KØREPRØVE</p>
                                    <p class="pa-1 card-r text-capitalize text-grey-dark card-r grey lighten-3">
                                      10.1 - Betingelser for at få kørekort</p>
                                    </span>
                          <v-btn v-show="!read" @click="read = true" class="w-100 card-r ma-0 text-capitalize no-shadow" small>readmore</v-btn>
                          <v-btn v-show="read" @click="read = false" class="w-100 card-r ma-0 text-capitalize no-shadow" small>less</v-btn>

                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-container>
                </v-flex>
              </v-layout>
            </v-card>
          </v-dialog>
        </v-layout>
        <v-layout row wrap class="">
          <div class="w-100" xs12 v-for="(cls,ind) in Classes" :key="ind">
            <v-flex class="pb-0" v-for="(card,index) in Classes[ind].class_details.non_booked_modules".
                    :key="card.id" v-if="card.type==(selectedFilter=='all'?card.type:selectedFilter)">
              <!--<div v-if="cls.payment=='paid'" class="text-xs-left textColor text-uppercase f-12 font-weight-bold">{{cls.class_details.name}}</div>-->
              <v-card class="no-shadow card-r">
                <router-link :to="'/viewclass/'+card.id" class="no-deraction">
                  <!--<v-btn :to="{name:Viewclass,props:{id:card.id}}" class="no-height ma-0 pb-0 card-r no-shadow">-->
                  <v-img :src="card.image" height="150px" class="top-r align-center">
                    <v-container fill-height fluid pa-2 >
                      <v-layout fill-height>
                        <v-flex xs12 align-end flexbox>
                          <span class="f-20 white--text t-shadow word-break" v-text="card.name"></span>
                          <div class="f-15 white--text t-shadow word-break" v-text="card.location"></div>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-img>
                </router-link>
                <v-card-actions class="pa-0">
                  <v-btn slot="activator"
                         class= "w-100 bottom-r btnM no-shadow text-white"
                         v-if="card.can_book"
                         color="mainBackG"
                         :to="{name:'BookingCalender',params:{moduleId:card.id,packageId:cls.package_id,className:card.name}}">{{$t('student_home_page.book_class_button')}}</v-btn>
                  <v-btn slot="activator"
                         v-if="!card.can_book" :to="{name:'Payment',params:{id:cls.package_id,bookedId:cls.id,backPage:true}}"
                         class= "w-100 bottom-r btnM no-shadow text-white mainBackG">Pay Now</v-btn>
                </v-card-actions>

              </v-card>
            </v-flex>
          </div>
          <v-dialog  class="pa-0 border-r card-r display-unset w-100" v-model="ChangeTime" width="600">

            <v-card class="card-r no-shadow">
              <v-layout row xs12 justify-center>
                <v-flex xs12>
                  <v-layout wrap>
                    <v-flex xs12 class=" ma-2">
                      <div class="text-sm-left f-20 pl-2" color="#002d4a"  >Book Class - {{selectedClass}}</div>
                    </v-flex>
                    <v-divider></v-divider>
                  </v-layout>
                  <v-container fluid grid-list-xl>
                    <v-layout row wrap class="">
                      <v-flex d-flex lg4   xs12 class="textFeald date">
                        <v-menu
                          ref="menu1"
                          v-model="birthday"
                          :close-on-content-click="false"
                          lazy
                          full-width
                          persistent
                          max-width="290px"
                          min-width="290px"
                        >
                          <v-text-field
                            slot="activator"
                            v-model="dob"
                            class=""
                            label="Select Date"
                            persistent-hint
                            :disabled="loading"
                            value="John Doe"
                            outline
                            placeholder="dd/mm/yyyy"
                          ></v-text-field>
                          <v-date-picker v-model="dob" :events="arrayEvents" @input="GetTime(dob)" event-color="green" :disabled="loading" no-title scrollable>
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click="birthday = false">Cancel</v-btn>
                            <v-btn flat color="primary" @click="setdate(dob)">OK</v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex d-flex lg4   xs12 class="textFeald w-100">
                        <v-select
                          v-model="selectedTime"
                          :items="timeslot"
                          item-text="time_from"
                          item-value="id"
                          class="input-group--focused w-100"
                          placeholder="select your time"
                          :disabled="loading"
                          outline
                        ></v-select>
                      </v-flex>
                      <v-flex d-flex class="text-xs-center pt-9" xs12 sm12 lg12 style="margin:auto">
                        <pulse-loader :loading="loading" :color="'#004d98'"></pulse-loader>



                        <v-btn @click="BookClass(selectedClassId,selectedClassPackageId)" v-if="!loading" larg depressed class="no-shadow card-r ml-4 mr-4" color="primary">Book Class</v-btn>
                      </v-flex>
                      <v-flex>
                        <v-alert
                          v-if="alertType=='success'"
                          :value="true"
                          color="success"
                          icon="check_circle"
                          outline
                        >
                          {{msg}}
                        </v-alert>
                        <v-alert
                          v-if="alertType=='warning'"
                          :value="true"
                          color="error"
                          icon="warning"
                          outline
                        >
                          {{msg}}
                        </v-alert>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
              </v-layout>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-container>
      </v-flex>
    </v-layout>
    </div>
</template>
<script>
  /* eslint-disable */
  import router from "@/router"

  export default {
    components:{
    },
    data() {
      return {
        clss:"",
        loading:false,
        ChangeTime: false,
        Classes: false,
        viewcls: false,
        read: false,
        selectedTime: "",
        selectedClass:'',
        selectedClassId:'',
        selectedClassPackageId:'',
        verified:'',
        msg:'',
        msgText:'',
        alertType:'',
        arrayEvents:[],
        timeslot:[],
        teacherTime:'',
        birthday: false,
        dob: "",
        menu1: '',
        cards: [
          {
            type: 'practical',
            name: 'Urban Drive',
            img: 'https://backend.tittam.com/public/images/modules/teori.png',
            location: 'køreskolen',
            address: 'Dadestien 6, Sandby, 4171 Glumsø rewdgrgff',
            iconas: "fas fa-car",
          },
          {
            type: 'theory',
            name: 'Teori 2',
            img: 'https://backend.tittam.com/public/images/modules/k%C3%B8rsel.png',
            location: 'Mødes foran køreskolen',
            iconas: "fab fa-leanpub",
          },
          {
            type: 'practical',
            name: 'Kerb Driving ',
            img: 'https://www.mercedesbenzdrivingacademy.ca/wp-content/uploads/2017/04/mercedes-benz-driver-training-education.jpg',
            location: 'køreskolen',
            address: 'Dadestien 6, Sandby, 4171 Glumsø rewdgrgff',
            iconas: "fas fa-car",
          },
          {
            type: 'practical',
            name: 'Kenneth Driving',
            img: 'https://i.ytimg.com/vi/asy1qhZ9Dck/maxresdefault.jpg',
            location: 'køreskolen',
            address: 'Dadestien 6, Sandby, 4171 Glumsø rewdgrgff',
            iconas: "fas fa-car",
          },
          {
            type: 'theory',
            name: 'Teori 1',
            img: 'https://i.ytimg.com/vi/asy1qhZ9Dck/maxresdefault.jpg',
            location: 'Køreskolen',
            iconas: "fab fa-leanpub",
          },
          {
            type: 'theory',
            name: 'Teori 3',
            img: 'https://backend.tittam.com/public/images/modules/glatbane.png',
            location: 'Næstved Køreteknisk anlæg - Man bliver hentet af en minibus foran Valby station.',
            iconas: "fab fa-leanpub",
          },
          {
            type: 'theory',
            name: 'Teori 4',
            img: 'https://backend.tittam.com/public/images/modules/glatbane.png',
            location: 'Næstved Køreteknisk anlæg - Man bliver hentet af en minibus foran Valby station.',
            iconas: "fab fa-leanpub",
          },
        ],
        seen: true,
        notifications:'',
        items: [],
        code:'',
        VerifyMsg:'',
        selectedFilter:'all'
      }
    },
    methods: {
      classtype(value){
        if (value=='theory') {
          router.push('/TheoryBook')
        }
        if (value=='practical') {
          router.push('/PracticalBook')
        }
      },
    }
  }
</script>
<style>
  .mb--5{
    margin-bottom: -5px!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/profile/student/new/MyClasses.vue